import React from 'react'
import { mainImage, mainImageOuter, akosLogo, lobbyImg, overFlowImg } from '../assets';
import { Typography } from '@mui/material';
const SubMainLobyComponent = () => {
    return (
        <>
            <div style={{ position: "relative" }}>
                <div style={{ height: "100vh", backgroundColor: '#000000' }}>
                    <img src={lobbyImg} alt="lobbyImg" width="100%" height="100%" />
                </div>

                {/* <div style={{
                    position: 'absolute',
                    top: '403px',
                    left: '120px'
                }}>

                </div> */}
                <div style={{
                    position: 'absolute',
                    bottom: '10%',
                    left: '20%',
                    flexDirection: 'row'
                }}>
                    <a href="" style={{ color: '#FFFFFF', display: "inline", textDecoration:'none', textShadow:'1px 1px #000000' }}>{`1.844.900.AKOS(2567) `}</a>
                    <a href="" style={{
                        color: '#FFFFFF', display: "inline", textDecoration: 'none',textShadow:'1px 1px #000000'
                    }}>| info@akosmd.com</a>

                </div>
                {/* <div style={{
                    position: 'absolute',
                    bottom: '88px',
                    left: '122px',
                    flexDirection: 'row'
                }}>
                    <Typography style={{ color: '#FFFFFF' }}><a>{`1.844.900.AKOS(2567)`}</a><span style={{
                        paddingLeft: 20,
                        paddingRight: 20
                    }}>|</span><a>info@akosmd.com</a></Typography>

                </div> */}
            </div>
        </>
    )
}

export default SubMainLobyComponent;